import { useEffect } from 'react'
import { supabase } from '../services/supabaseClient'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import { setNotificationBadges } from '../store/uiSlice'

function formatDue(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
}

export function useAssignmentBadges() {
  const dispatch = useAppDispatch()
  const teamId = useAppSelector((s) => s.auth.profile?.team_id ?? null)

  useEffect(() => {
    if (!teamId) {
      dispatch(setNotificationBadges({}))
      return
    }
    let cancelled = false

    async function load() {
      const { data } = await supabase
        .from('assignments')
        .select('tool_id, due_at')
        .eq('team_id', teamId)
        .eq('status', 'active')
        .order('due_at', { ascending: true })
      if (cancelled) return
      const badges: Record<string, string> = {}
      for (const row of (data ?? []) as Array<{ tool_id: string; due_at: string }>) {
        if (!(row.tool_id in badges)) {
          badges[row.tool_id] = `Due ${formatDue(row.due_at)}`
        }
      }
      dispatch(setNotificationBadges(badges))
    }

    load()
    return () => { cancelled = true }
  }, [teamId, dispatch])
}
